import {on} from 'node:events';
import {finished} from 'node:stream/promises';
import {nodeImports} from './stream.js';

Object.assign(nodeImports, {on, finished});

export {
	default,
	getStreamAsArray,
	getStreamAsArrayBuffer,
	getStreamAsBuffer,
	MaxBufferError,
} from './exports.js';
